export default "__VITE_ASSET__CLt1apF$__"